//Get id from match or if unavailable from override parameters for the form.
export const getIdFromProps = (props: any) => {
  return props.match?.params?.id || props.overrideParams?.id;
};

//Enhanced version of above with addition of a 'New' check to fallback on either id from values (Save & Continue support) or -1 to cause no matches.
export const getIdFromPropsForFilter = (props: any) => {
  const id = props.match?.params?.id || props.overrideParams?.id;

  let idValue = id === 'New' ? props.values?.id ?? -1 : id;

  if (idValue === null || idValue === undefined) {
    idValue = props.values?.id;
  }

  return idValue;
};
